import {toast as shadcnToast} from '@retracedgmbh/ui-components-lib'
import useTranslator from '@/hooks/useTranslator'

/**
 * @typedef {Object} Toast
 * @property {(message: string) => void} success - Show success toast
 * @property {(message: string) => void} error - Show error toast
 * @property {(message: string) => void} warning - Show warning toast
 * @property {(message: string) => void} info - Show info toast
 * @property {(customComponent: () => any) => void} custom - Show custom toast
 */

shadcnToast.success = message => shadcnToast({title: message, variant: 'success'})
shadcnToast.error = message => shadcnToast({title: message, variant: 'destructive'})
shadcnToast.warning = message => shadcnToast({title: message, variant: 'warning'})
shadcnToast.info = message => shadcnToast({title: message, variant: 'primary'})

/**
 * @returns {{toast: Toast & typeof shadcnToast}}
 */
const useToast = () => {
  const {getTranslation} = useTranslator({page: 'components'})

  shadcnToast.custom = customComponent =>
    shadcnToast({
      description: customComponent(),
      variant: 'destructive',
      title: getTranslation('components.errorToast.error'),
    })

  return {toast: shadcnToast}
}

export default useToast
